/**
 * Formats PQFL classification code to full description
 * @param classificacao - Classification code (C or D)
 * @returns Full classification description (without letter prefix)
 */
export const formatClassificacao = (classificacao: string): string => {
  const classificacaoMap: Record<string, string> = {
    C: 'Classificado',
    D: 'Desclassificado',
  };

  return classificacaoMap[classificacao] || classificacao;
};
